<template>
  <div v-if="hasGoal">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon color="green" dark v-bind="attrs" v-on="on">
          ✔
        </v-icon>
      </template>
      <span>Has Coaching Goal</span>
    </v-tooltip>
  </div>
  <div v-else>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon color="red" dark v-bind="attrs" v-on="on">
          mdi-alert-circle-outline
        </v-icon>
      </template>
      <span>This client does not have an active Coaching goal</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "Bhag",
  props: {
    hasGoal: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
